import { gql } from '@apollo/client'

export default gql(`
    mutation($deletedId: [ID]! $assetId: ID! $module: String) {
        deleteAssetVideos(
            input:  $deletedId,
            assetId: $assetId
            module : $module
        )
    }`
)
